export enum OrderStatus {
  noOrder = 'NO_ORDER', // used by OrderStatusIcon
  completed = 'COMPLETED',
  pending = 'PENDING',
  sending = 'SENDING', // used by OrderProgressBar
  failed = 'FAILED',
} // combination of TransactionStatus and UI

export enum TransactionStatus {
  completed = 'COMPLETED',
  pending = 'PENDING',
  error = 'ERROR', // check event could return error as the status
}

export enum LoyaltyResponseStatus {
  sending = 'ELOYALTYMEMBERSENDING',
  pending = 'ELOYALTYMEMBERCHECKING',
  valid = 'ELOYALTYMEMBERFOUND',
  invalid = 'ELOYALTYMEMBERNOTFOUND',
}

// SLA (Service Level Agreement): maximum acceptable time (ms) for an order to be fully processed from the moment it is sent until the check response is received
export const SLA_THRESHOLD_MS = 5000;
